import React from 'react';
import Carousel from '../Carousel';
import useBreakpoints from '../../hooks/useBreakPoint';
import acti from '../../images/partners/acti.png';
import americanTime from '../../images/partners/americanTime.png';
import aruba from '../../images/partners/aruba.png';
import avaya from '../../images/partners/avaya.png';
import avigilon from '../../images/partners/avigilon.png';
import axis from '../../images/partners/axis.png';
import belden from '../../images/partners/belden.png';
import berktek from '../../images/partners/berktek.png';
import bogen from '../../images/partners/bogen.png';
import bosch from '../../images/partners/bosch.png';
import carehawk from '../../images/partners/carehawk.png';
import cisco from '../../images/partners/cisco.png';
import crestron from '../../images/partners/crestron.png';
import dante from '../../images/partners/dante.png';
import dsc from '../../images/partners/dsc.png';
import dukane from '../../images/partners/dukane.png';
import extron from '../../images/partners/extron.png';
import fci from '../../images/partners/fci.png';
import firelite from '../../images/partners/firelite.png';
import hitachi from '../../images/partners/hitachi.png';
import hubbel from '../../images/partners/hubbel.png';
import kantech from '../../images/partners/kantech.png';
import legrand from '../../images/partners/legrand.png';
import meraki from '../../images/partners/meraki.png';
import mitel from '../../images/partners/mitel.png';
import mohawk from '../../images/partners/mohawk.png';
import monaco from '../../images/partners/monaco.png';
import nec from '../../images/partners/nec.png';
import occ from '../../images/partners/occ.png';
import onssi from '../../images/partners/onssi.png';
import ortronics from '../../images/partners/ortronics.png';
import planar from '../../images/partners/planar.png';
import primex from '../../images/partners/primex.png';
import s2 from '../../images/partners/s2.png';
import sapling from '../../images/partners/sapling.png';
import shure from '../../images/partners/shure.png';
import siemon from '../../images/partners/siemon.png';
import silentKnight from '../../images/partners/silentKnight.png';
import superiorEssex from '../../images/partners/superiorEssex.png';
import ubiquiti from '../../images/partners/ubiquiti.png';
import valcom from '../../images/partners/valcom.png';
import vingtor from '../../images/partners/vingtor.png';
import zyxel from '../../images/partners/zyxel.png';

const partners = [
  {
    id: 1, src: acti, alt: 'acti', href: 'https://www.acti.com/',
  },
  {
    id: 2,
    src: americanTime,
    alt: 'american time',
    href: 'https://www.american-time.com/',
  },
  {
    id: 3, src: aruba, alt: 'aruba', href: 'https://www.arubanetworks.com/',
  },
  {
    id: 4, src: avaya, alt: 'avaya', href: 'https://www.avaya.com/en/',
  },
  {
    id: 5, src: avigilon, alt: 'avigilon', href: 'https://www.avigilon.com/',
  },
  {
    id: 6, src: axis, alt: 'axis', href: 'https://www.axis.com/en-us',
  },
  {
    id: 7, src: belden, alt: 'belden', href: 'https://www.belden.com/',
  },
  {
    id: 8, src: berktek, alt: 'berktek', href: 'https://www.berktek.us/',
  },
  {
    id: 9, src: bogen, alt: 'bogen', href: 'https://www.bogen-paging.com/',
  },
  {
    id: 10, src: bosch, alt: 'bosch', href: 'https://www.bosch-home.com/us/',
  },
  {
    id: 11, src: carehawk, alt: 'carehawk', href: 'https://www.carehawk.com/',
  },
  {
    id: 12, src: cisco, alt: 'cisco', href: 'https://www.cisco.com/',
  },
  {
    id: 13, src: crestron, alt: 'crestron', href: 'https://www.crestron.com/',
  },
  {
    id: 14, src: dante, alt: 'dante', href: 'https://www.audinate.com/',
  },
  {
    id: 15, src: dsc, alt: 'dsc', href: 'https://www.dsc.com/',
  },
  {
    id: 16, src: dukane, alt: 'dukane', href: 'http://dukaneav.com/',
  },
  {
    id: 17, src: extron, alt: 'extron', href: 'https://www.extron.com/',
  },
  {
    id: 18, src: fci, alt: 'fci', href: 'https://www.gamewell-fci.com/en-US/',
  },
  {
    id: 19,
    src: firelite,
    alt: 'firelite',
    href: 'http://www.firelite.com/en-US/',
  },
  {
    id: 20, src: hitachi, alt: 'hitachi', href: 'https://www.hitachi.com/',
  },
  {
    id: 21, src: hubbel, alt: 'hubbel', href: 'https://www.hubbell.com/',
  },
  {
    id: 22, src: kantech, alt: 'kantech', href: 'https://www.kantech.com/',
  },
  {
    id: 23, src: legrand, alt: 'legrand', href: 'https://www.legrand.us/',
  },
  {
    id: 24, src: meraki, alt: 'meraki', href: 'https://meraki.cisco.com/',
  },
  {
    id: 25, src: mitel, alt: 'mitel', href: 'https://www.mitel.com',
  },
  {
    id: 26, src: mohawk, alt: 'mohawk', href: 'http://www.mohawk-cable.com/',
  },
  {
    id: 27, src: monaco, alt: 'monaco', href: 'https://www.monaco.com/',
  },
  {
    id: 28, src: nec, alt: 'nec', href: 'https://www.nec.com/',
  },
  {
    id: 29, src: occ, alt: 'occ', href: 'https://www.occfiber.com/',
  },
  {
    id: 30, src: onssi, alt: 'onssi', href: 'https://onssi.com/onssi/',
  },
  {
    id: 31,
    src: ortronics,
    alt: 'ortronics',
    href: 'https://www.legrand.us/ortronics',
  },
  {
    id: 32, src: planar, alt: 'planar', href: 'https://www.planar.com/',
  },
  {
    id: 33, src: primex, alt: 'primex', href: 'https://www.primexinc.com/',
  },
  {
    id: 34, src: s2, alt: 's2', href: 'https://www.s2sys.com/',
  },
  {
    id: 35, src: sapling, alt: 'sapling', href: 'https://sapling-inc.com/',
  },
  {
    id: 36, src: shure, alt: 'shure', href: 'https://www.shure.com/en-US',
  },
  {
    id: 37, src: siemon, alt: 'siemon', href: 'https://www.siemon.com/',
  },
  {
    id: 38,
    src: silentKnight,
    alt: 'silentKnight',
    href: 'https://www.silentknight.com',
  },
  {
    id: 39,
    src: superiorEssex,
    alt: 'superiorEssex',
    href: 'https://superioressexcommunications.com/',
  },
  {
    id: 40, src: ubiquiti, alt: 'ubiquiti', href: 'https://www.ui.com/',
  },
  {
    id: 41, src: valcom, alt: 'valcom', href: 'https://www.valcom.com/',
  },
  {
    id: 42, src: vingtor, alt: 'vingtor', href: 'https://www.zenitel.com/',
  },
  {
    id: 43, src: zyxel, alt: 'zyxel', href: 'https://www.zyxel.com/us/en/',
  },
];

const Partner = () => {
  const {
    isMd, isLg, is2xl, is3xl,
  } = useBreakpoints();
  return (
    <div className="px-5 py-8 md:px-11 md:py-9 lg:px-26 lg:py-9 2xl:px-30 2xl:py-14 3xl:px-44 3xl:py-17">
      <Carousel
        slidesToShow={is3xl ? 5 : is2xl ? 6 : isLg ? 5 : isMd ? 6 : 3}
        gap={16}
        infiniteAutoplay
        slideDisplayTime={isMd ? 5700 : 5000}
      >
        {partners
          .sort(() => Math.random() - 0.5)
          .map(({
            id, src, alt, href,
          }) => (
            <div
              key={id}
              className="flex items-center px-2 w-25 h-14 lg:w-37.5 lg:h-21 2xl:w-50 2xl:h-28 2xl:px-3 3xl:w-75 3xl:h-42 3xl:px-4"
            >
              <a
                href={href}
                target="_blank"
                rel="noreferrer"
                className="block text-center"
              >
                <img src={src} alt={alt} />
              </a>
            </div>
          ))}
      </Carousel>
    </div>
  );
};

export default Partner;
